// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_fb-0";
export var fulfillmentPanelBody = "_fb-1";